// Use custom environment variable or fallback to NODE_ENV check
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.vista-invest.org'
    : 'http://localhost:3001');

// Debug logging
console.log('API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  hasCustomApiUrl: !!process.env.REACT_APP_API_URL,
  usingBaseUrl: !!API_BASE_URL,
});

export { API_BASE_URL };
